module.exports = __webpack_public_path__ + "static/img/flopmachine_th.6db5bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/flopmachine_th.png
// module id = Y1MJ
// module chunks = 1